var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"clickable"},[_c('td',[_vm._v(" "+_vm._s(_vm.base.name)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.base.address)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.base.country.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }